import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { map, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { CategoriesStorage, TabCategory, CategoryNaturalKey } from '../documents';
import { Site } from '../sites/site';
import { DocumentsTabsCategoriesComponentBase } from './base/document-tabs-categories-component-base';
import { routeData, routeParams } from '../shared/route-helpers';

@Component({
    selector: 'documents-tabs-categories',
    template: require('./base/documents-tabs-categories-component-base.html'),
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentsTabsComponent extends DocumentsTabsCategoriesComponentBase {
    constructor(
        private route: ActivatedRoute,
        urlBuilder: UrlBuilder,
        private categoriesStorage: CategoriesStorage,
    ) {
        super(urlBuilder);
    }

    protected createTabsCategories(): Observable<TabCategory[]> {
        const site = this.route.parent.data.pipe(map(data => data[routeData.selectedSite] as Site | undefined));
        const categoryId = this.route.params.pipe(map(x => x[routeParams.categoryId] as CategoryNaturalKey | undefined));

        const category = categoryId.pipe(switchMap(x => this.categoriesStorage.findCategoryById(x)));
        const childCategories = category.pipe(switchMap(x => this.categoriesStorage.getChildCategoriesById(x.categoryId)));

        const tabsSubCategories = combineLatest(
            site,
            category,
            childCategories
        ).pipe(
            map(([siteValue, categoryValue, childCategoriesValue]) => {
                if (!childCategoriesValue) {
                    return [];
                }

                const tabs = super.createTabs(siteValue, categoryValue, childCategoriesValue);

                // Single tabs should not be displayed
                if (tabs.length === 1) {
                    return [];
                }

                return tabs;
            }),
            publishReplay(1),
            refCount()
        );

        return tabsSubCategories;
    }
}